import { IModularityUtilConfigurator } from "./IModularityUtilConfigurator";
/**
 * Created by rkamysz on 4/30/2015.
 */

// TODO: @HTML5 class IModuleCommandConfigurator don't exist in robotlegs module
// import { IModuleCommandConfigurator } from "../../../robotlegs/modular/moduleSignalCommandMap/dsl/IModuleCommandConfigurator";

export class ModularityUtilConfigurator implements IModularityUtilConfigurator {
    // private _commandConfigurator: IModuleCommandConfigurator;
    private _commandConfigurator: any;

    // constructor(commandConfigurator: IModuleCommandConfigurator) {
    constructor(commandConfigurator: any) {
        this._commandConfigurator = commandConfigurator;
    }

    public toCommand(commandName: string): void {
        this._commandConfigurator.withPayloadConverter(new Converter(commandName).convert);
    }
}

class Converter {
    private _commandName: string;

    constructor(commandName: string) {
        this._commandName = commandName;

    }

    public convert(params: any[]): any[] {
        params.unshift(this._commandName);
        return params;
    }
}
